<template>
	<div>
		<h3>CONTA BANCÁRIA DO ESTABELECIMENTO PARA RECEBÍVEIS</h3>

		<b-form class="mt-4">
			<b-form-row>
				<b-col cols="12">
					<input-component v-model="name" :required="true" label="Razão social" maxlength="255" name="name" />
				</b-col>
			</b-form-row>

			<b-form-row>
				<b-col cols="12">
					<input-component
						v-model="taxId"
						:check="true"
						:mask="'##.###.###/####-##'"
						:required="true"
						label="CNPJ"
						maxlength="30"
						name="taxId" />
				</b-col>
			</b-form-row>

			<b-form-row>
				<b-col cols="12">
					<select-component
						v-model="selectedBank"
						:options="bankOptions"
						:required="true"
						label="Banco"
						name="selectedBank"
						@input="handleSelectedBankChange" />
				</b-col>
			</b-form-row>

			<b-form-row>
				<b-col cols="12" md="6">
					<input-component v-model="agency" :required="true" label="Agência" maxlength="10" name="agency" />
				</b-col>

				<b-col cols="12" md="6">
					<input-component
						v-model="account"
						:required="true"
						label="Conta corrente (com dígito verificador)"
						maxlength="20"
						name="account" />
				</b-col>
			</b-form-row>
		</b-form>

		<p>Verifique se todos os dados preenchidos e a documentação anexada estão corretos.</p>
	</div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import InputComponent from "@/components/Form/Inputs/InputComponent";
import SelectComponent from "./Inputs/SelectComponent.vue";
import { getBankOptions } from "../../services/BankService";
import { mapBankListToOptions } from "../../helpers/bankHelper";

export default {
	name: "BankFormComponent",
	components: { SelectComponent, InputComponent },
	props: { validationTrigger: Boolean },
	data() {
		return {
			bankOptions: [],
		};
	},
	async mounted() {
		if (this.$store.state.form.bankAccount.name) {
			this.$v.$touch();
		}

		this.$emit("setReadyToSubmit", this.isValid);
		await this.$store.dispatch("updateStep", this.step);
		await this.loadBankOptions();

		// Se houver um número, preenche o campo de banco selecionado
		if (this.number) {
			this.selectedBank = this.bankOptions.find((item) => item.number == this.number);
		}
	},
	methods: {
		handleSelectedBankChange(e) {
			this.number = e.number;
			this.bank = e.bank;
		},
		async loadBankOptions() {
			// Realiza a requisição para buscar as opções de banco
			const bankList = await getBankOptions();

			// Mapeia os dados recebidos para o formato esperado pelo componente de select
			const bankOptions = mapBankListToOptions(bankList);

			// Atualiza as opções de banco no componente
			this.bankOptions = bankOptions;
		},
	},
	watch: {
		isValid(value) {
			this.$emit("setReadyToSubmit", value);
		},
		validationTrigger() {
			this.$emit("setReadyToSubmit", this.isValid);
		},
	},
	computed: {
		isValid() {
			return !this.$v.$invalid;
		},
		name: {
			get() {
				return this.$store.state.form.bankAccount.name;
			},
			set(value) {
				this.$store.commit("setBankAccount", {
					key: "name",
					value,
				});
			},
		},
		taxId: {
			get() {
				return this.$store.state.form.bankAccount.taxId;
			},
			set(value) {
				this.$store.commit("setBankAccount", {
					key: "taxId",
					value,
				});
			},
		},
		bank: {
			get() {
				return this.$store.state.form.bankAccount.bank;
			},
			set(value) {
				this.$store.commit("setBankAccount", {
					key: "bank",
					value,
				});
			},
		},
		selectedBank: {
			get() {
				return this.$store.state.form.bankAccount.selectedBank;
			},
			set(value) {
				this.$store.commit("setBankAccount", {
					key: "selectedBank",
					value,
				});
			},
		},
		number: {
			get() {
				return this.$store.state.form.bankAccount.number;
			},
			set(value) {
				this.$store.commit("setBankAccount", {
					key: "number",
					value,
				});
			},
		},
		agency: {
			get() {
				return this.$store.state.form.bankAccount.agency;
			},
			set(value) {
				this.$store.commit("setBankAccount", {
					key: "agency",
					value,
				});
			},
		},
		account: {
			get() {
				return this.$store.state.form.bankAccount.account;
			},
			set(value) {
				this.$store.commit("setBankAccount", {
					key: "account",
					value,
				});
			},
		},
		step() {
			return this.$store.state.form.step;
		},
	},
	validations: {
		name: {
			required,
		},
		taxId: {
			required,
			isValidCNPJ: function (taxId) {
				return this.$root.isValidCNPJ(taxId);
			},
		},
		bank: {},
		number: {},
		agency: {
			required,
		},
		account: {
			required,
		},
		selectedBank: {
			required,
		},
	},
};
</script>

<style lang="scss" scoped>
p {
	color: #c2c0bf !important;
	font-family: "Nunito Sans";
	font-size: 14px;
}
</style>
